"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _invitationType = require("../../store/gift/invitationType");

var _gift = require("../../store/gift/gift.selector");

var _gift2 = require("../../store/gift/gift.actions");

var _features = require("../../../Shared/store/features");

var _PresetSchedule = _interopRequireDefault(require("./PresetSchedule"));

var _CustomSchedule = _interopRequireDefault(require("./CustomSchedule"));

var _userTrackGiftSchedule = require("./userTrackGiftSchedule");

var didInit = false;

var SendGiftButton = function SendGiftButton(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isCustomSchedule = _useState2[0],
      setIsCustomSchedule = _useState2[1];

  var scheduleButtonRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isSchedulePopperVisible = _useState4[0],
      setSchedulePopperVisible = _useState4[1];

  var isLinkInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedLinkInvitationType);
  var isEmailInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedEmailInvitationType);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var recipientEmail = (0, _reactRedux.useSelector)(_gift.getGiftRecipientEmail);
  var isGiftSendingCompleted = (0, _reactRedux.useSelector)(_gift.getIsGiftSendingCompleted);
  var isGiftContactSyncCompleted = (0, _reactRedux.useSelector)(_gift.getIsGiftContactSyncCompleted);
  var isGiftContactSyncIdle = (0, _reactRedux.useSelector)(_gift.getIsGiftContactSyncIdle);
  var trackScheduleClicked = (0, _userTrackGiftSchedule.useTrackGiftScheduleClicked)();
  var hasSalesforceHasOptedOutFF = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.SALESFORCE_HAS_OPTED_OUT));
  var campaignId = (0, _reactRedux.useSelector)(_gift.getGiftCampaignId);

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(campaignId || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var teamId = campaign === null || campaign === void 0 ? void 0 : campaign.team.id;

  if (!didInit) {
    // These lines will run before the component is mounted in the DOM, so before the useEffect is triggered,
    // similar to a constructor. This way se can reset the store to init a new flow.
    didInit = true;
    dispatch((0, _gift2.giftSendReset)());
    dispatch((0, _gift2.giftVerifyAvailableContactReset)());
  }

  (0, _react.useEffect)(function () {
    if (hasSalesforceHasOptedOutFF && recipientEmail && isGiftContactSyncIdle && isGiftSendingCompleted) {
      dispatch((0, _gift2.giftVerifyAvailableContact)(recipientEmail));
    }
  }, [dispatch, isGiftContactSyncIdle, isGiftSendingCompleted, hasSalesforceHasOptedOutFF, recipientEmail]);
  (0, _react.useEffect)(function () {
    if (isGiftSendingCompleted && isGiftContactSyncCompleted) {
      dispatch((0, _gift2.giftLoadRequest)(giftId));
    }
  }, [dispatch, giftId, isGiftContactSyncCompleted, isGiftSendingCompleted]);
  var handleDropDownToggle = (0, _react.useCallback)(function () {
    if (!isSchedulePopperVisible) {
      trackScheduleClicked();
    }

    setIsCustomSchedule(false);
    setSchedulePopperVisible(!isSchedulePopperVisible);
  }, [trackScheduleClicked, isSchedulePopperVisible]);
  var handleClose = (0, _react.useCallback)(function () {
    setIsCustomSchedule(false);
    setSchedulePopperVisible(false);
  }, []);
  var handleSendGift = (0, _react.useCallback)(function () {
    trackEvent('Gifting flow — clicked send gift', {
      gift_id: giftId,
      team_id: teamId
    });
    dispatch((0, _gift2.giftSendRequest)(giftId));
  }, [giftId, teamId, trackEvent, dispatch]);
  var handleSelectPreset = (0, _react.useCallback)(function (preset) {
    if (preset) {
      dispatch((0, _gift2.giftSendRequest)(giftId, preset));
    } else {
      setIsCustomSchedule(true);
    }
  }, [dispatch, giftId]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.ButtonGroup, {
    ref: scheduleButtonRef,
    disabled: disabled,
    variant: "contained",
    color: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: handleSendGift,
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: ['fab', 'telegram-plane'],
      color: "inherit"
    })
  }, isLinkInvitationType ? 'Generate invite link' : 'Send invite'), isEmailInvitationType && /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: handleDropDownToggle
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: isSchedulePopperVisible ? 'chevron-up' : 'chevron-down',
    color: "inherit"
  }))), isEmailInvitationType && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PresetSchedule.default, {
    onSchedule: handleSelectPreset,
    open: isSchedulePopperVisible && !isCustomSchedule,
    anchorEl: scheduleButtonRef.current,
    onClose: handleClose
  }), /*#__PURE__*/_react.default.createElement(_CustomSchedule.default, {
    onSchedule: handleSelectPreset,
    open: isSchedulePopperVisible && isCustomSchedule,
    anchorEl: scheduleButtonRef.current,
    onClose: handleClose
  })));
};

var _default = SendGiftButton;
exports.default = _default;